export default "__VITE_ASSET__54$a4aaV__"